/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Gender {
  M = 'M',
  F = 'F',
  NA = 'NA',
}
